import qs from 'qs'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const loginApi = ({ username, password }) => {
  const data = qs.stringify({
    grant_type: '',
    username,
    password,
    scope: '',
    client_id: '',
    client_secret: '',
  })

  const config = {
    method: 'post',
    url: '/api/v1/login',
    headers: {
      accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.access_token) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getUser = ({ profile_id, employee_name, token }) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    method: 'get',
    url: `/api/v1/user/`,
    params: { profile_id, employee_name },
  }
  return defaultInstance
    .request(config)
    .then((res) => {
      if (res?.data) {
        return responseSuccess({ data: res?.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      return responseError({ message: err.message })
    })
}
